import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnuncioService } from '../../services/anuncio.service';
import { ResultadoPesquisaInternaAnuncio } from '../../models/resultado-pesquisa-anuncio.model';
import { ParametrosMeusAnunciosGoverno } from '../../models/parametros-meus-anuncios-governo.model';
import { AnunciosInternoLista } from '../common/anuncios-interno-lista';
import { OrigemEnum } from 'app/shared/enum/origem.enum';
import { ChaveValor } from 'app/anuncio/models/comuns';
import { Anuncio } from 'app/anuncio/models/anuncio.model';
import { AlterarTipoAnuncioComponent } from '../alterar-tipo-anuncio/alterar-tipo-anunciocomponent';
import { LiberarAnuncioComponent } from '../liberar-anuncio/liberar-anuncio.component';

@Component({
  selector: 'reuse-meus-anuncios-governo-lista',
  templateUrl: './meus-anuncios-governo-lista.component.html',
  styleUrls: ['./meus-anuncios-governo-lista.component.scss']
})
export class MeusAnunciosGovernoListaComponent extends AnunciosInternoLista implements OnInit {

  MEUS_ANUNCIOS_GOVERNO = OrigemEnum.MEUS_ANUNCIOS_GOVERNO;
  // indicador para verificar se os dados do backend já foram recebidos.
  carregouDados: boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private anuncioService: AnuncioService) {
      super();
    }

  ngOnInit() {
    this.monitorarUrl();
    this.montarOpcoesOrdenacao();
    this.tamanhoPagina = 18;
  }


  @ViewChild('liberarFinalizarAnuncio') liberarFinalizarAnuncio: LiberarAnuncioComponent;
  @ViewChild('alterarTipoAnuncio') alterarTipoAnuncio: AlterarTipoAnuncioComponent;

  /**
   * Monitora a url, sempre que houver mudanças nos parâmetros, realiza nova consulta de anúncios.
   */
  monitorarUrl() {
    this.route.queryParams.subscribe(
      params => {
        const parametros: ParametrosMeusAnunciosGoverno = this.anuncioService.obterParametrosMeusAnunciosGovernoUrl(params);
        this.ordem = parametros.ordem;
        this.anuncioService.consultarMeusAnunciosGoverno(parametros).subscribe(
          (resultado: ResultadoPesquisaInternaAnuncio) => {
            this.anuncios = resultado.anuncios;
            this.totalRegistros = resultado.totalRegistros;
            this.inicio = resultado.inicio;
            this.carregouDados = true;
            window.scrollTo(0,0);
          });
      });
  }



  /**
   * Consulta os meus anúncios, utilizando os parâmetros/filtros da url.
   */
  consultarAnunciosComParametrosUrl() {
    const parametrosUrl = this.route.snapshot.queryParams;
    const parametros: ParametrosMeusAnunciosGoverno = this.anuncioService.obterParametrosMeusAnunciosGovernoUrl(parametrosUrl);

    this.router.navigate([OrigemEnum.MEUS_ANUNCIOS_GOVERNO], {
      queryParams: {
        pesquisa: parametros.pesquisa,
        materialTipos: parametros.materialTipos,
        materialCategorias: parametros.materialCategorias,
        materialSituacoes: parametros.materialSituacoes,
        ufs: parametros.ufs,
        periodoInclusao: parametros.periodoInclusao,
        periodoExpiracao: parametros.periodoExpiracao,
        anuncios: parametros.anuncios,
        entidades: parametros.entidades,
        inicio: this.inicio,
        ordem: this.ordem
      }
    });
  }

  public showModalLiberarFinalizar(anuncio: Anuncio) {
    this.liberarFinalizarAnuncio.exibirModalLiberar(anuncio);
  }

  public abrirModalAlterarTipoAnuncio(anuncio: Anuncio) {
    this.alterarTipoAnuncio.abrirModalAlterarTipoAnuncio(anuncio);
  }

}
